export async function fetchOrganisationBaseAirfieldIcao(supabase, organisationId) {
  if (!organisationId) return '';

  const { data, error } = await supabase
    .from('airfields')
    .select('icao')
    .eq('organisation_id', organisationId)
    .maybeSingle();

  if (error) return '';

  const icao = String(data?.icao || '').trim().toUpperCase();

  return icao;
}

// DB airfield wins whenever usable; localStorage settings are only a resilience fallback.
export function resolveBaseAirfield(databaseBaseAirfield, settingsBaseAirfield) {
  const resolved = databaseBaseAirfield || settingsBaseAirfield || '';

  return resolved;
}
